import { View } from "@react-pdf/renderer";

const PdfDivider = () => (
  <View
    style={{
      borderBottomWidth: 1,
      borderBottomColor: "#eeeeee",
      marginVertical: 10,
    }}
  />
);

export default PdfDivider;
